import React, { Component } from 'react';
import { enableAnimations } from 'config/helpers';
import { AbsoluteCTA } from 'components';
import { ContactBanner } from 'views/contact/subcomponents';
import {
  Banner,
  Process,
  Reasons,
  OurArticles,
  AwwwardsSlider,
} from './subcomponents';
import './WhyDesignMatters.scss';

class WhyDesignMatters extends Component {
  componentDidMount() {
    enableAnimations();
  }

  render() {
    const { allArticles } = this.props;

    return (
      <div className={'single-case-study wdm__container'}>
        <Banner />
        <Reasons />
        <div id={'designs'} className={'wdm__section wdm__showcase'}>
          <AwwwardsSlider />
        </div>
        <Process className={'wdm__section'} />
        <ContactBanner
          dataPdWebforms={
            'https://webforms.pipedrive.com/f/cs9dOxJOmE5gaVtA984VfwEuPoJdBsZgEEtvPiKgr6U3hcEK0dU8ApHM9rhP1RzZtx'
          }
        />
        <div className={'wdm__container--desktop'}>
          <OurArticles allArticles={allArticles} />
        </div>
        <div className={'wdm__container--mobile'} id={'wdm-contact-mobile'}>
          <AbsoluteCTA linkID={'why-design-matters'} />
        </div>
      </div>
    );
  }
}

export default WhyDesignMatters;
